// import './NewsletterForm.scss';

import { b2x } from '@b2x/react/src';

import { Button } from '../Button';
import { t } from '../i18n/i18n';

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesFormValues = {};

// eslint-disable-next-line @typescript-eslint/ban-types
type AdditionalPropertiesValidationSchema = b2x.yup.ObjectSchema<{}>;

export type NewsletterFormProps = Omit<
  b2x.NewsletterFormProps<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>,
  | 'additionalPropertiesInitialValues'
  | 'additionalProperties'
  | 'additionalPropertiesValidationSchema'
  | 'validationSchemaSelector'
>;

export const NewsletterForm = ({ emailFieldStyle = 'textInput', ...otherProps }: NewsletterFormProps) => {
  return (
    <b2x.NewsletterFormHelper<AdditionalPropertiesFormValues, AdditionalPropertiesValidationSchema>
      {...otherProps}
      emailFieldStyle={emailFieldStyle}
      redirectToHomeOnSuccessModalClose
      validationSchemaSelector={{ name: false, surname: false }}
    >
      {({ fieldsHelper }) => (
        <>
          {emailFieldStyle === 'inputGroup' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
              <b2x.InputGroup {...fieldsHelper.email.inputGroup}>
                <b2x.TextInput className="me-3 rounded-pill" {...fieldsHelper.email.textInput} />
                <Button
                  {...fieldsHelper.buttons.submit}
                  className="rounded-pill"
                  label={t('form.newsletterForm.buttons.submit.label')}
                  variant="outline-secondary"
                />
              </b2x.InputGroup>
            </b2x.FormGroup>
          )}
          {emailFieldStyle === 'textInput' && (
            <b2x.FormGroup {...fieldsHelper.email.formGroup} label={undefined}>
              <b2x.TextInput {...fieldsHelper.email.textInput} />
            </b2x.FormGroup>
          )}
          <fieldset>
            <legend className="visually-hidden">{fieldsHelper.consents.legend}</legend>
            <b2x.FormGroup {...fieldsHelper.consents.newsletterConsent.formGroup} label={undefined}>
              <b2x.Checkbox
                {...fieldsHelper.consents.newsletterConsent.checkbox}
                labelClassName="extra-small text-start text-gray-500"
              />
            </b2x.FormGroup>
          </fieldset>
          {emailFieldStyle === 'textInput' && (
            <div className="d-block">
              {/* <b2x.Button {...fieldsHelper.buttons.submit} className="w-100 btn-secondary-outline" /> */}
              <Button
                {...fieldsHelper.buttons.submit}
                className="rounded-pill"
                label={t('form.newsletterForm.buttons.submit.label')}
                variant="outline-secondary"
              />
            </div>
          )}
        </>
      )}
    </b2x.NewsletterFormHelper>
  );
};
